import React from "react";
import GLOBAL_CONFIG from "../../../config/config";
import Aux from "../../../hoc/Auxiliare";
import parse from "html-react-parser";
import { NavLink } from "react-router-dom";
import { timeStamp } from "../../../modules/helpers";
import appGoogleTracking from "../../../modules/googletracking";
/*
  Contains the step that a user must do to participate in the campaign
*/

const StepContent = (props) => {
	let { title, toScroll,isMobile } = props,
		contenStep = null,
		promotionCampaign = window.PROMOTION_CAMPAIGN;
	const { t } = props;
// console.log('test', toScroll)
	const getTaggingPlan= (()=>{
		if (window.location.pathname.toLowerCase() ===GLOBAL_CONFIG.Route.home.toLowerCase()) {
			return (
				<div className="content-home__container">
					<NavLink
						to={GLOBAL_CONFIG.Route.home}
						exact
						data-event="join_now"
						data-category="Start Page"
						data-action="Click on Join Now"
						data-label="ENG_SP_OTHER"
						onClick={(e) => {
							appGoogleTracking.processEventCTANavLink(e);
							const particaptionForm = document.getElementById('frm_participation');
							if (particaptionForm) {
								particaptionForm.scrollIntoView({behavior: 'smooth'});
								toScroll();
							}
							}
						}
					>
						<div className="btn__container btn--primary btn--hover">
							
							<span className="btn__text" style={{ fontSize: '16px' }}>
								{t("Page.Home.linkParticipation")}
							</span>
						</div>
					</NavLink>
					<p className="redirect-terms" style={{fontSize:'16px'}}>
						<NavLink
							to={GLOBAL_CONFIG.Route.terms}
							exact
							data-event="click_conditions"
							data-category="Start Page"
							data-action="Click on Conditions of Participation"
							data-label="ENG_SP_PART"
							onClick={appGoogleTracking.processEventCTANavLink}
							target="_blank"
						>
							Teilnahmebedingungen
						</NavLink>{" "}
						des Gewinnspiels
					</p>
				</div>
			)
		} else if (window.location.pathname.toLowerCase() === GLOBAL_CONFIG.Route.participation.toLowerCase()) {
			return (
				<div className="content-home__container">
					<NavLink
						to={GLOBAL_CONFIG.Route.participation}
						exact
						data-event="join_now"
						data-category="Take Part Page"
						data-action="Click on Join Now"
						data-label="EASTER_TPP_PART"
						onClick={appGoogleTracking.processEventCTANavLink}
					>
						<div className="btn__container btn--primary btn--hover" >
							
							{/* <a
								className="to-scroll"
								data-event="upload_receipt_link"
								data-category="Take Part Page"
								data-action="Click on link"
								data-label="GAME_SP_PART"
								onClick={toScroll}
							>
								hier
							</a>{" "} */}
							<span className="btn__text" onClick={toScroll} style={{ fontSize: '16px' }}>
								{t("Page.Home.linkParticipation")}
							</span>
						</div>
					</NavLink>
					<p className="redirect-terms" style={{ fontSize: '16px' }}>
						<NavLink

							to={GLOBAL_CONFIG.Route.terms}
							exact
							data-event="click_conditions_join_now"
							data-category="Take Part Page"
							data-action="Click on Conditions"
							data-label="ENG_TPP_PART"
							onClick={appGoogleTracking.processEventCTANavLink}
							target="_blank"
						>
							Teilnahmebedingungen
						</NavLink>{" "}
						des Gewinnspiels
					</p>
				</div>

			)
		} else{
			return (
				<div className="content-home__container">
					<NavLink
						to={GLOBAL_CONFIG.Route.faq}
						exact
						data-event="join_now"
						data-category="FAQ Page"
						data-action="Click on Join Now"
						data-label="EASTER_FAQ_FORM"
						onClick={(e) => {
							appGoogleTracking.processEventCTANavLink(e);
							const particaptionForm = document.getElementById('frm_participation');
							if (particaptionForm) {
								particaptionForm.scrollIntoView({behavior: 'smooth'});
								toScroll();
							}
							}
						}
					>
						<div className="btn__container btn--primary btn--hover">
							

							{(promotionCampaign === "gluecksrad")
								? (<span className="btn__text">JETZT TEILNEHMEN</span>)
								: (<span className="btn__text">
									{t("Page.Home.linkParticipation")}
								</span>)
							}

						</div>
					</NavLink>
					<p className="redirect-terms" style={{ fontSize: '16px' }}>
						<NavLink
							to={GLOBAL_CONFIG.Route.terms}
							exact
							data-event="click_conditions_join_now"
							data-category="FAQ Page"
							data-action="Click on Conditions"
							data-label="ENG_FAQ_FORM"
							onClick={appGoogleTracking.processEventCTANavLink}
							target="_blank"
						>
							Teilnahmebedingungen
						</NavLink>{" "}
						des Gewinnspiels
					</p>
				</div>

			)
		}
	});
	// alert(promotionCampaign);
	if (promotionCampaign === "alle") {
		if (
			window.location.pathname.toLowerCase() ===
			GLOBAL_CONFIG.Route.home.toLowerCase()
		) {
			contenStep = (
				<Aux>
					<h2>{title}</h2>

					<div className="s-content-steps__step first">
						<picture>
							<img
								src="/resources/images/alle/step1.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy first">
							<p>
								<strong>Jetzt registrieren</strong>
							</p>
						</div>
					</div>

					<div className="s-content-steps__step second">
						<picture>
							<img
								src="/resources/images/alle/step2.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy second">
							<p>
								<strong>Mit etwas Glück<br />
									deinen<br />
									personalisierten<br /> Teilnahmecode per <br />E-Mail erhalten</strong>


							</p>
						</div>
					</div>

					<div className="s-content-steps__step third">
						<picture>
							<img
								src="/resources/images/alle/step3.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy third">
							<p>
								<strong>
									Milka Nascher-Ei kaufen, Kaufbeleg bis zum 31.03.2024 hochladen
									und Kaufpreis erstattet bekommen
								</strong>
							</p>
						</div>
					</div>
				</Aux>
			);
		} else {
			contenStep = (
				<Aux>
					<h2>{title}</h2>

					<div className="s-content-steps__step first">
						<picture>
							<img
								src="/resources/images/alle/step1.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy first">
							<p>
								<strong>Jetzt registrieren</strong>
							</p>
						</div>
					</div>

					<div className="s-content-steps__step second">
						<picture>
							<img
								src="/resources/images/alle/step2.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy second">
							<p>
								<strong>Mit etwas Glück<br />
									deinen<br />
									personalisierten<br /> Teilnahmecode per <br />E-Mail erhalten</strong>


							</p>
						</div>
					</div>

					<div className="s-content-steps__step third">
						<picture>
							<img
								src="/resources/images/alle/step3.png"
								className="s-content-steps__image"
								alt="Participation Steps"
							/>
						</picture>
						<div className="s-content-steps__copy third">
							<p>
								<strong>
									Milka Nascher-Ei kaufen, Kaufbeleg bis zum 31.03.2024 hochladen
									und Kaufpreis erstattet bekommen
								</strong>
							</p>
						</div>
					</div>
				</Aux>
			);
		}
	} else if (promotionCampaign === "kaufland"){
		contenStep = (
			<Aux>
				<div className="container-steps">
					<>
						<h2>{title}</h2>
						<div className="container-steps__steps">
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-1.png"}
										alt="Step 1"
									/>
								</div>
								<p className="s-content-steps__item__text">
									5 x Milka in einem <br />Kaufakt bei Kaufland <br />kaufen
								</p>
							</div>
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-2.png"}
										alt="Step 2"
									/>
								</div>
								
									{
										window.location.pathname.toLowerCase() === GLOBAL_CONFIG.Route.participation.toLowerCase() ?
										(<p className="small s-content-steps__item__text">Kaufbeleg <a href="#section1">hier</a><br /> bis zum 31.03.2024 <br /> hochladen. </p>)
										: (<p className="small s-content-steps__item__text">Kaufbeleg <a href="/mitmachen">hier</a><br /> bis zum 31.03.2024 <br /> hochladen. </p>)
									}

							</div>
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-3.png"}
										alt="Step 2"
									/>
								</div>
								<p className="s-content-steps__item__text">
									Täglich 1 von 10 <br />Kaufland-<br />Geschenkkarten im<br /> Wert von maximal<br /> 200 € gewinnen
								</p>
							</div>
						</div>
						{getTaggingPlan()}
					</>
				</div>

			</Aux>
		);
	}
	else {

		contenStep = (
			<Aux>
				<div className="container-steps">
					<>
						<h2>{title}</h2>
						<div className="container-steps__steps">
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-1.png"}
										alt="Step 1"
									/>
								</div>
								{(promotionCampaign==="edeka")
									? (<p className="s-content-steps__item__text">
										Kaufe 2 Milka <br/> Produkte
									</p>)
									: (<p className="s-content-steps__item__text">
										Kaufe 2 Milka <br/> Produkte
									</p>)
								}
							</div>
							<div className="s-content-steps__item">
								<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-2.png"}
										alt="Step 2"
									/>
								</div>
								<p className="small s-content-steps__item__text">
									Lade die Rechnung <br/> 
									
									<NavLink
										to={GLOBAL_CONFIG.Route.home}
										style={{fontFamily: 'Lörrach Heavy', textDecoration: 'underline'}}
										exact
										data-event="upload_receipt"
										data-category="Start Page"
										data-action="Click on Upload Receipt"
										data-label="GAME_SP_FORM"
										onClick={(e) => {
											appGoogleTracking.processEventCTANavLink(e);
											const particaptionForm = document.getElementById('frm_participation');
											if (particaptionForm) {
												particaptionForm.scrollIntoView({behavior: 'smooth'});
												toScroll();
											}
											}
										}
									>
										hier 
									</NavLink>
									&nbsp;hoch
								</p>
							</div>
							<div className="s-content-steps__item">
							<div className="s-content-steps__item-image">
									<img
										src={"/resources/images/" + promotionCampaign + "/step-3.png"}
										alt="Step 3"
									/>
								</div>
								<p className="s-content-steps__item__text">
									Dreh das virtuelle <br/> Glücksrad und <br/> gewinne mit etwas Glück
								</p>
							</div>
						</div>
						{getTaggingPlan()}
					</>
				</div>

			</Aux>
		);

	}
	return <div className="s-content-steps">{contenStep}</div>;
};

export default StepContent;
